/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthExtensionRouteImport } from './routes/auth/extension'
import { Route as AuthEmailLinkRouteImport } from './routes/auth/email-link'
import { Route as AuthedNotificationsRouteImport } from './routes/_authed/notifications'
import { Route as AuthedMyRequestsRouteImport } from './routes/_authed/my-requests'
import { Route as AuthedSuperadminStakesRouteImport } from './routes/_authed/superadmin/stakes'
import { Route as AuthedStakeWardsRouteImport } from './routes/_authed/stake/wards'
import { Route as AuthedStakeRosterRouteImport } from './routes/_authed/stake/roster'
import { Route as AuthedManagerSeatsRouteImport } from './routes/_authed/manager/seats'
import { Route as AuthedManagerQueueRouteImport } from './routes/_authed/manager/queue'
import { Route as AuthedManagerDashboardRouteImport } from './routes/_authed/manager/dashboard'
import { Route as AuthedManagerConfigurationRouteImport } from './routes/_authed/manager/configuration'
import { Route as AuthedManagerAuditRouteImport } from './routes/_authed/manager/audit'
import { Route as AuthedManagerAccessRouteImport } from './routes/_authed/manager/access'
import { Route as AuthedBishopricRosterRouteImport } from './routes/_authed/bishopric/roster'

const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthExtensionRoute = AuthExtensionRouteImport.update({
  id: '/auth/extension',
  path: '/auth/extension',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthEmailLinkRoute = AuthEmailLinkRouteImport.update({
  id: '/auth/email-link',
  path: '/auth/email-link',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedNotificationsRoute = AuthedNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMyRequestsRoute = AuthedMyRequestsRouteImport.update({
  id: '/my-requests',
  path: '/my-requests',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSuperadminStakesRoute = AuthedSuperadminStakesRouteImport.update({
  id: '/superadmin/stakes',
  path: '/superadmin/stakes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStakeWardsRoute = AuthedStakeWardsRouteImport.update({
  id: '/stake/wards',
  path: '/stake/wards',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStakeRosterRoute = AuthedStakeRosterRouteImport.update({
  id: '/stake/roster',
  path: '/stake/roster',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedManagerSeatsRoute = AuthedManagerSeatsRouteImport.update({
  id: '/manager/seats',
  path: '/manager/seats',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedManagerQueueRoute = AuthedManagerQueueRouteImport.update({
  id: '/manager/queue',
  path: '/manager/queue',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedManagerDashboardRoute = AuthedManagerDashboardRouteImport.update({
  id: '/manager/dashboard',
  path: '/manager/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedManagerConfigurationRoute =
  AuthedManagerConfigurationRouteImport.update({
    id: '/manager/configuration',
    path: '/manager/configuration',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedManagerAuditRoute = AuthedManagerAuditRouteImport.update({
  id: '/manager/audit',
  path: '/manager/audit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedManagerAccessRoute = AuthedManagerAccessRouteImport.update({
  id: '/manager/access',
  path: '/manager/access',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBishopricRosterRoute = AuthedBishopricRosterRouteImport.update({
  id: '/bishopric/roster',
  path: '/bishopric/roster',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/my-requests': typeof AuthedMyRequestsRoute
  '/notifications': typeof AuthedNotificationsRoute
  '/auth/email-link': typeof AuthEmailLinkRoute
  '/auth/extension': typeof AuthExtensionRoute
  '/bishopric/roster': typeof AuthedBishopricRosterRoute
  '/manager/access': typeof AuthedManagerAccessRoute
  '/manager/audit': typeof AuthedManagerAuditRoute
  '/manager/configuration': typeof AuthedManagerConfigurationRoute
  '/manager/dashboard': typeof AuthedManagerDashboardRoute
  '/manager/queue': typeof AuthedManagerQueueRoute
  '/manager/seats': typeof AuthedManagerSeatsRoute
  '/stake/roster': typeof AuthedStakeRosterRoute
  '/stake/wards': typeof AuthedStakeWardsRoute
  '/superadmin/stakes': typeof AuthedSuperadminStakesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/my-requests': typeof AuthedMyRequestsRoute
  '/notifications': typeof AuthedNotificationsRoute
  '/auth/email-link': typeof AuthEmailLinkRoute
  '/auth/extension': typeof AuthExtensionRoute
  '/bishopric/roster': typeof AuthedBishopricRosterRoute
  '/manager/access': typeof AuthedManagerAccessRoute
  '/manager/audit': typeof AuthedManagerAuditRoute
  '/manager/configuration': typeof AuthedManagerConfigurationRoute
  '/manager/dashboard': typeof AuthedManagerDashboardRoute
  '/manager/queue': typeof AuthedManagerQueueRoute
  '/manager/seats': typeof AuthedManagerSeatsRoute
  '/stake/roster': typeof AuthedStakeRosterRoute
  '/stake/wards': typeof AuthedStakeWardsRoute
  '/superadmin/stakes': typeof AuthedSuperadminStakesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/_authed/my-requests': typeof AuthedMyRequestsRoute
  '/_authed/notifications': typeof AuthedNotificationsRoute
  '/auth/email-link': typeof AuthEmailLinkRoute
  '/auth/extension': typeof AuthExtensionRoute
  '/_authed/bishopric/roster': typeof AuthedBishopricRosterRoute
  '/_authed/manager/access': typeof AuthedManagerAccessRoute
  '/_authed/manager/audit': typeof AuthedManagerAuditRoute
  '/_authed/manager/configuration': typeof AuthedManagerConfigurationRoute
  '/_authed/manager/dashboard': typeof AuthedManagerDashboardRoute
  '/_authed/manager/queue': typeof AuthedManagerQueueRoute
  '/_authed/manager/seats': typeof AuthedManagerSeatsRoute
  '/_authed/stake/roster': typeof AuthedStakeRosterRoute
  '/_authed/stake/wards': typeof AuthedStakeWardsRoute
  '/_authed/superadmin/stakes': typeof AuthedSuperadminStakesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/privacy'
    | '/my-requests'
    | '/notifications'
    | '/auth/email-link'
    | '/auth/extension'
    | '/bishopric/roster'
    | '/manager/access'
    | '/manager/audit'
    | '/manager/configuration'
    | '/manager/dashboard'
    | '/manager/queue'
    | '/manager/seats'
    | '/stake/roster'
    | '/stake/wards'
    | '/superadmin/stakes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy'
    | '/my-requests'
    | '/notifications'
    | '/auth/email-link'
    | '/auth/extension'
    | '/bishopric/roster'
    | '/manager/access'
    | '/manager/audit'
    | '/manager/configuration'
    | '/manager/dashboard'
    | '/manager/queue'
    | '/manager/seats'
    | '/stake/roster'
    | '/stake/wards'
    | '/superadmin/stakes'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/privacy'
    | '/_authed/my-requests'
    | '/_authed/notifications'
    | '/auth/email-link'
    | '/auth/extension'
    | '/_authed/bishopric/roster'
    | '/_authed/manager/access'
    | '/_authed/manager/audit'
    | '/_authed/manager/configuration'
    | '/_authed/manager/dashboard'
    | '/_authed/manager/queue'
    | '/_authed/manager/seats'
    | '/_authed/stake/roster'
    | '/_authed/stake/wards'
    | '/_authed/superadmin/stakes'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  AuthEmailLinkRoute: typeof AuthEmailLinkRoute
  AuthExtensionRoute: typeof AuthExtensionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/extension': {
      id: '/auth/extension'
      path: '/auth/extension'
      fullPath: '/auth/extension'
      preLoaderRoute: typeof AuthExtensionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/email-link': {
      id: '/auth/email-link'
      path: '/auth/email-link'
      fullPath: '/auth/email-link'
      preLoaderRoute: typeof AuthEmailLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/notifications': {
      id: '/_authed/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthedNotificationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/my-requests': {
      id: '/_authed/my-requests'
      path: '/my-requests'
      fullPath: '/my-requests'
      preLoaderRoute: typeof AuthedMyRequestsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/superadmin/stakes': {
      id: '/_authed/superadmin/stakes'
      path: '/superadmin/stakes'
      fullPath: '/superadmin/stakes'
      preLoaderRoute: typeof AuthedSuperadminStakesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stake/wards': {
      id: '/_authed/stake/wards'
      path: '/stake/wards'
      fullPath: '/stake/wards'
      preLoaderRoute: typeof AuthedStakeWardsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stake/roster': {
      id: '/_authed/stake/roster'
      path: '/stake/roster'
      fullPath: '/stake/roster'
      preLoaderRoute: typeof AuthedStakeRosterRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/manager/seats': {
      id: '/_authed/manager/seats'
      path: '/manager/seats'
      fullPath: '/manager/seats'
      preLoaderRoute: typeof AuthedManagerSeatsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/manager/queue': {
      id: '/_authed/manager/queue'
      path: '/manager/queue'
      fullPath: '/manager/queue'
      preLoaderRoute: typeof AuthedManagerQueueRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/manager/dashboard': {
      id: '/_authed/manager/dashboard'
      path: '/manager/dashboard'
      fullPath: '/manager/dashboard'
      preLoaderRoute: typeof AuthedManagerDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/manager/configuration': {
      id: '/_authed/manager/configuration'
      path: '/manager/configuration'
      fullPath: '/manager/configuration'
      preLoaderRoute: typeof AuthedManagerConfigurationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/manager/audit': {
      id: '/_authed/manager/audit'
      path: '/manager/audit'
      fullPath: '/manager/audit'
      preLoaderRoute: typeof AuthedManagerAuditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/manager/access': {
      id: '/_authed/manager/access'
      path: '/manager/access'
      fullPath: '/manager/access'
      preLoaderRoute: typeof AuthedManagerAccessRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/bishopric/roster': {
      id: '/_authed/bishopric/roster'
      path: '/bishopric/roster'
      fullPath: '/bishopric/roster'
      preLoaderRoute: typeof AuthedBishopricRosterRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedMyRequestsRoute: typeof AuthedMyRequestsRoute
  AuthedNotificationsRoute: typeof AuthedNotificationsRoute
  AuthedBishopricRosterRoute: typeof AuthedBishopricRosterRoute
  AuthedManagerAccessRoute: typeof AuthedManagerAccessRoute
  AuthedManagerAuditRoute: typeof AuthedManagerAuditRoute
  AuthedManagerConfigurationRoute: typeof AuthedManagerConfigurationRoute
  AuthedManagerDashboardRoute: typeof AuthedManagerDashboardRoute
  AuthedManagerQueueRoute: typeof AuthedManagerQueueRoute
  AuthedManagerSeatsRoute: typeof AuthedManagerSeatsRoute
  AuthedStakeRosterRoute: typeof AuthedStakeRosterRoute
  AuthedStakeWardsRoute: typeof AuthedStakeWardsRoute
  AuthedSuperadminStakesRoute: typeof AuthedSuperadminStakesRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedMyRequestsRoute: AuthedMyRequestsRoute,
  AuthedNotificationsRoute: AuthedNotificationsRoute,
  AuthedBishopricRosterRoute: AuthedBishopricRosterRoute,
  AuthedManagerAccessRoute: AuthedManagerAccessRoute,
  AuthedManagerAuditRoute: AuthedManagerAuditRoute,
  AuthedManagerConfigurationRoute: AuthedManagerConfigurationRoute,
  AuthedManagerDashboardRoute: AuthedManagerDashboardRoute,
  AuthedManagerQueueRoute: AuthedManagerQueueRoute,
  AuthedManagerSeatsRoute: AuthedManagerSeatsRoute,
  AuthedStakeRosterRoute: AuthedStakeRosterRoute,
  AuthedStakeWardsRoute: AuthedStakeWardsRoute,
  AuthedSuperadminStakesRoute: AuthedSuperadminStakesRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  AuthEmailLinkRoute: AuthEmailLinkRoute,
  AuthExtensionRoute: AuthExtensionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
